import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export interface InvestmentsAdminSummaryType {
  totalAssets: number;
  assetTypes: number;
}

export type InvestmentsAdminSummaryScope = "reliance" | "other";

export default function useGetInvestmentsAdminSummary(
  scope: InvestmentsAdminSummaryScope,
  enabled = true,
) {
  return useQuery({
    queryKey: ["investments/admin/summary", scope],
    queryFn: async () => {
      return axiosInstance
        .get("/investments/admin/summary", {
          params: { scope },
        })
        .then((res) => res.data);
    },
    retry: false,
    enabled,
    staleTime: 1000 * 60,
  });
}
